import React from 'react';
import { Routes, Route } from 'react-router-dom';
import NewHomePage from './pages/NewHomePage/NewHomePage';
import NewNavbar from './components/NewNavbar/NewNavbar';
import NewFooter from './components/NewFooter/NewFooter';
import NewAboutUs from './pages/NewAboutUs/NewAboutUs';
import ContactPage from './pages/Contact/Contact';
import Events from './pages/Events/Events';
import ScrollToTop from './components/Utility/ScrollToTop';
import Account from './pages/Account/Account';
import FAQ from './pages/FAQ/FAQ';
import AuthRedirect from './components/Utility/AuthRedirect';
import TermsOfUse from './pages/Privacy_Terms/TermsofUse';
import PrivacyPolicy from './pages/Privacy_Terms/PrivacyPolicy';

function App() {
  return (
    <div
      id="appjs-div"
      style={{ position: 'relative', overflow: 'visible', height: 'auto', minHeight: '100vh' }}
    >
      <NewNavbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<NewHomePage />} />
        <Route path="/about" element={<NewAboutUs />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/events" element={<Events />} />
        <Route path="/account" element={<Account />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/auth/callback" element={<AuthRedirect />} />
      </Routes>
      <NewFooter />
    </div>
  );
}

export default App;
